import '../styles/AddWeightButton.css'

import { useState } from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';

import Modal from './Modal';

const AddWeightButton = ({ onAddNewWeight, weightUnit }) => {
  const [isAddingNewWeight, setIsAddingNewWeight] = useState(false)

  return(
    <div className='addWeightButton'>
      <BsFillPlusCircleFill className='addWeightButtonIcon' onClick={() => setIsAddingNewWeight(true)}/>
      {isAddingNewWeight && <Modal setIsUsingModal={setIsAddingNewWeight} onSubmitAction={onAddNewWeight} weightUnit={weightUnit} title="Add New Weight"/>}
    </div>
  )
}

export default AddWeightButton